import { forwardRef, type InputHTMLAttributes } from 'react';
import { colors } from './tokens';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> & {
  size?: 'sm' | 'md';
  label?: string;
};

export const Switch = forwardRef<HTMLInputElement, Props>(function Switch(
  { size = 'md', label, checked, disabled, style, ...rest },
  ref,
) {
  const w = size === 'sm' ? 26 : 32;
  const h = size === 'sm' ? 16 : 20;
  const thumb = h - 4;
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: label ? 10 : 0,
        cursor: disabled ? 'not-allowed' : 'pointer',
        userSelect: 'none',
        opacity: disabled ? 0.5 : 1,
        ...style,
      }}
    >
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        style={{ position: 'absolute', opacity: 0, width: 0, height: 0, pointerEvents: 'none' }}
        {...rest}
      />
      <span
        aria-hidden
        style={{
          width: w,
          height: h,
          borderRadius: h / 2,
          background: checked ? colors.accent : colors.line2,
          position: 'relative',
          transition: 'background 0.15s',
          flexShrink: 0,
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: 2,
            left: checked ? w - thumb - 2 : 2,
            width: thumb,
            height: thumb,
            borderRadius: '50%',
            background: colors.surface,
            transition: 'left 0.15s',
            boxShadow: '0 1px 2px rgba(17,17,20,0.18)',
          }}
        />
      </span>
      {label && <span style={{ fontSize: 13, color: colors.ink2 }}>{label}</span>}
    </label>
  );
});
